import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "className", "style", "ariaLabel", "title", "type", "inputId", "defaultValue", "value", "placeholder", "allowClear", "revealer", "onChange", "onKeyDown", "onKeyUp", "onClick", "onBlur", "onFocus", "readonly", "textReadonly", "disabled", "error", "required", "errorNode", "prefix", "suffix", "children", "name", "maxLength", "hideTitleOnInput", "tabIndex", "phoneTag", "dropdown", "selectedItem", "defaultSelectedItem", "dpShowPlaceholder", "isOpen", "dpEditable", "onClear", "dropdownChange", "prefixTemplate", "suffixTemplate", "dpSuffixTemplate", "dpDate", "onRef", "customIcon", "inputProps", "inputRef"];
// @ts-nocheck
import * as React from 'react';
import { useCallback } from 'react';
import ClassNames from 'classnames';
import { useControlled, KEY_VALUES, mergeRefs } from '../utils';
import { DropdownButton } from '../dropdown';
import { useLocalization } from '@appkit4/react-api';
var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _fieldDropdownButtonL;
  var id = props.id,
    className = props.className,
    style = props.style,
    ariaLabel = props.ariaLabel,
    title = props.title,
    typeProp = props.type,
    _props$inputId = props.inputId,
    inputId = _props$inputId === void 0 ? id || String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now() : _props$inputId,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
    valueProp = props.value,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$allowClear = props.allowClear,
    allowClear = _props$allowClear === void 0 ? false : _props$allowClear,
    _props$revealer = props.revealer,
    revealer = _props$revealer === void 0 ? false : _props$revealer,
    onChange = props.onChange,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    onClick = props.onClick,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    readonly = props.readonly,
    textReadonly = props.textReadonly,
    disabled = props.disabled,
    error = props.error,
    required = props.required,
    errorNode = props.errorNode,
    prefix = props.prefix,
    suffix = props.suffix,
    children = props.children,
    name = props.name,
    maxLength = props.maxLength,
    _props$hideTitleOnInp = props.hideTitleOnInput,
    hideTitleOnInput = _props$hideTitleOnInp === void 0 ? false : _props$hideTitleOnInp,
    tabIndexProp = props.tabIndex,
    _props$phoneTag = props.phoneTag,
    phoneTag = _props$phoneTag === void 0 ? false : _props$phoneTag,
    dropdown = props.dropdown,
    selectedItemProp = props.selectedItem,
    defaultSelectedItem = props.defaultSelectedItem,
    dpShowPlaceholder = props.dpShowPlaceholder,
    isOpen = props.isOpen,
    _props$dpEditable = props.dpEditable,
    dpEditable = _props$dpEditable === void 0 ? true : _props$dpEditable,
    onClear = props.onClear,
    dropdownChange = props.dropdownChange,
    prefixTemplate = props.prefixTemplate,
    suffixTemplate = props.suffixTemplate,
    dpSuffixTemplate = props.dpSuffixTemplate,
    dpDate = props.dpDate,
    onRef = props.onRef,
    customIcon = props.customIcon,
    inputProps = props.inputProps,
    inputRefProp = props.inputRef,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _React$useState = React.useState(0),
    startDate = _React$useState[0],
    setStartDate = _React$useState[1];
  var _React$useState2 = React.useState(0),
    endDate = _React$useState2[0],
    setEndDate = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    isEditing = _React$useState3[0],
    setIsEditing = _React$useState3[1];
  var _React$useState4 = React.useState(false),
    keyboardFocus = _React$useState4[0],
    setKeyboardFocus = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    dpSuffix = _React$useState5[0],
    setDpSuffix = _React$useState5[1];
  var _React$useState6 = React.useState(false),
    clickFocus = _React$useState6[0],
    setClickFocus = _React$useState6[1];
  var _useControlled = useControlled(valueProp, defaultValue),
    value = _useControlled[0],
    setValue = _useControlled[1];
  var _React$useState7 = React.useState(typeProp),
    type = _React$useState7[0],
    setType = _React$useState7[1];
  var _React$useState8 = React.useState(false),
    showPlaceholder = _React$useState8[0],
    setShowPlaceholder = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    dpKeyEventShowPlaceholder = _React$useState9[0],
    setDpKeyEventShowPlaceholder = _React$useState9[1];
  var _React$useState10 = React.useState(false),
    visible = _React$useState10[0],
    setVisible = _React$useState10[1];
  var _useControlled2 = useControlled(selectedItemProp, defaultSelectedItem),
    selectedItem = _useControlled2[0],
    setSelectedItem = _useControlled2[1];
  var tagRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var wrapperRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;

  /**
   * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
   *
   * @param {String} text The text to be rendered.
   * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
   * @param {String} letterSpacing The letter spacing value.
   * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
   */
  var getTextWidth = function getTextWidth(text, font, letterSpacing) {
    // re-use canvas object for better performance
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    context.font = font;
    context.letterSpacing = letterSpacing;
    var metrics = context.measureText(text);
    return metrics.width;
  };
  var setInputSuffixPosition = function setInputSuffixPosition() {
    setTimeout(function () {
      var slotted = document.querySelector('.ap-field-input-suffix');
      var suffix = slotted === null || slotted === void 0 ? void 0 : slotted.childNodes[0];
      if (suffix) {
        suffix.style.position = 'absolute';
        suffix.style.left = getTextWidth(props.value, '16px PwC Helvetica Neue', '-0.4px') + 8 + 'px';
        suffix.style.display = 'initial';
      }
    });
  };
  React.useEffect(function () {
    onRef === null || onRef === void 0 ? void 0 : onRef([tagRef, inputRef, wrapperRef]);
  }, []);
  React.useEffect(function () {
    setInputSuffixPosition();
  });
  React.useEffect(function () {
    var eventClickHandler = function eventClickHandler(event) {
      if (containerRef.current && containerRef.current.contains(event.target) && clickFocus) {
        return false;
      } else if (containerRef.current && containerRef.current.contains(event.target) && !clickFocus && !disabled && !readonly) {
        setClickFocus(true);
      }
    };
    window.addEventListener('click', eventClickHandler);
    return function () {
      window.removeEventListener('click', eventClickHandler);
    };
  }, []);
  var handleClick = function handleClick(event) {
    // if (disabled || readonly) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   return;
    // }
    inputRef.current.focus();
    setKeyboardFocus(false);
    if (value === '' || value === undefined) {
      setShowPlaceholder(true);
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };
  var onkeydown = function onkeydown(event) {
    // if (disabled || readonly) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   return;
    // }
    if (event.key === KEY_VALUES.TAB) {
      setKeyboardFocus(true);
      setClickFocus(true);
      if (event.target !== inputRef.current) {
        setClickFocus(false);
      }
      if (value === '' || value === undefined) {
        setShowPlaceholder(true);
      }
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  };
  var handleChange = function handleChange(event) {
    var newValue = event.target.value;
    setValue(newValue);
    setIsEditing(true);
    onChange === null || onChange === void 0 ? void 0 : onChange(newValue, event);
  };
  var onKeyUpHandle = function onKeyUpHandle(event) {
    // if (disabled || readonly) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   return;
    // }
    var newValue = event.target.value;
    setValue(newValue);
    onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(event);
    setDpKeyEventShowPlaceholder(true);
  };
  var handleInputBlur = useCallback(function (event) {
    // if (disabled || readonly) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   return;
    // }
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    setDpKeyEventShowPlaceholder(false);
    setClickFocus(false);
    setStartDate(Date.now());
    setIsEditing(false);
  }, [onBlur]);
  var handleInputFocus = useCallback(function (event) {
    // if (disabled || readonly) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   return;
    // }
    setClickFocus(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    setEndDate(Date.now());
    setIsEditing(false);
  }, [onFocus]);
  var fieldTitleWrapperClass = ClassNames('ap-field-title-container', {
    required: required
  });
  var fieldWrapperClass = ClassNames('ap-field', className, {
    'has-length': value !== '',
    readonly: readonly,
    'text-readonly': textReadonly,
    error: error,
    disabled: disabled,
    'ap-field-dropdown-phone': phoneTag
  });
  var fieldContainerClass = ClassNames('ap-field-container', {
    'hide-title': hideTitleOnInput,
    show: visible,
    open: dpShowPlaceholder
  });
  var clearWrapperClass = ClassNames('ap-field-cleaner ap-field-icon-btn Appkit4-icon icon-circle-delete-outline', {
    disabled: value === '',
    readonly: readonly
  });
  var _React$useState11 = React.useState(true),
    reveal = _React$useState11[0],
    setReveal = _React$useState11[1];
  var changeReveal = function changeReveal() {
    if (value === '') return;
    setReveal(!reveal);
    setType(reveal ? 'text' : 'password');
    setTimeout(function () {
      inputRef.current.setSelectionRange(-1, -1);
    }, 0);
  };
  var changeRevealKeyDown = function changeRevealKeyDown(event) {
    if (value === '') return;
    if (event.key === KEY_VALUES.ENTER) {
      setReveal(!reveal);
      setType(reveal ? 'text' : 'password');
      setTimeout(function () {
        inputRef.current.setSelectionRange(-1, -1);
      }, 0);
    }
  };
  var revealWrapperClass = ClassNames('Appkit4-icon ap-field-icon-btn ap-field-password-reveal-icon', {
    'icon-view-outline': reveal,
    'icon-view-off-outline': !reveal,
    disabled: value === ''
  });
  var handleClear = function handleClear(event) {
    setValue('');
    onChange === null || onChange === void 0 ? void 0 : onChange('', event);
    onClear === null || onClear === void 0 ? void 0 : onClear(event);
    inputRef.current.focus();
  };
  var handleClearKeyDown = function handleClearKeyDown(event) {
    if (event.key === KEY_VALUES.ENTER) {
      setValue('');
      onChange === null || onChange === void 0 ? void 0 : onChange('', event);
      onClear === null || onClear === void 0 ? void 0 : onClear(event);
      inputRef.current.focus();
      setClickFocus(true);
    }
  };
  React.useEffect(function () {
    var tagWidth;
    if (tagRef.current) {
      tagWidth = tagRef.current.getBoundingClientRect().width;
      inputRef.current.style['padding-left'] = tagWidth + 2 + 'px';
    }
  }, [selectedItem]);
  var dropdownSelectHandle = function dropdownSelectHandle(itemValue, item) {
    if (item.value !== (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value)) {
      setSelectedItem(item);
      dropdownChange === null || dropdownChange === void 0 ? void 0 : dropdownChange(value, item);
    }
    setClickFocus(true);
    inputRef.current.focus();
    setVisible(false);
  };
  var onVisibleChange = function onVisibleChange(visible) {
    setVisible(visible);
  };
  var tabIndex = disabled || readonly ? -1 : tabIndexProp;
  var placeholderCls = ClassNames('ap-field-placeholder-container', {
    'has-no-title': hideTitleOnInput
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: fieldWrapperClass,
    style: style,
    ref: ref,
    onKeyUp: onkeydown,
    id: "field-wrapper-" + inputId
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: fieldContainerClass,
    ref: containerRef
  }, /*#__PURE__*/React.createElement("div", {
    className: fieldTitleWrapperClass
  }, /*#__PURE__*/React.createElement("label", {
    className: "ap-field-title",
    htmlFor: "field-input-" + inputId,
    id: "field-input-label-" + inputId,
    "aria-owns": "field-input-" + inputId,
    "aria-disabled": "false"
  }, title || placeholder)), /*#__PURE__*/React.createElement("div", {
    className: ClassNames('ap-field-wrapper', {
      'keyboard-focus': keyboardFocus,
      focus: clickFocus
    }),
    onClick: !readonly && !disabled ? handleClick : undefined,
    ref: wrapperRef
  }, prefix && /*#__PURE__*/React.createElement("div", {
    className: "ap-field-prefix-wrapper"
  }, prefix), phoneTag && /*#__PURE__*/React.createElement("div", {
    className: "ap-field-dropdown-phone-tag",
    ref: tagRef
  }, selectedItem && selectedItem.descValue), /*#__PURE__*/React.createElement("input", _extends({
    type: type,
    className: "ap-field-input " + (allowClear || revealer || suffix ? 'shorter-input' : ''),
    ref: mergeRefs(inputRef, inputRefProp),
    id: "field-input-" + inputId,
    "aria-invalid": error,
    "aria-required": required,
    value: value,
    name: name,
    maxLength: maxLength,
    onChange: handleChange,
    onBlur: handleInputBlur,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUpHandle,
    onFocus: handleInputFocus,
    readOnly: readonly || textReadonly,
    disabled: disabled || readonly,
    "aria-label": ariaLabel || '',
    tabIndex: tabIndex
  }, inputProps)), /*#__PURE__*/React.createElement("div", {
    className: "ap-field-input-suffix"
  }, /*#__PURE__*/React.createElement("div", null, !isEditing && value && !isOpen && dpSuffixTemplate && dpSuffixTemplate(dpDate) ? dpSuffixTemplate(dpDate) : null)), !hideTitleOnInput ? placeholder && (showPlaceholder || dpShowPlaceholder && value === '' || dpKeyEventShowPlaceholder && value === '') && dpEditable && /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: placeholderCls
  }, /*#__PURE__*/React.createElement("span", {
    className: "ap-field-placeholder"
  }, placeholder)) : '', dropdown && dropdown.length > 0 && /*#__PURE__*/React.createElement(DropdownButton, {
    dropdownClassName: 'ap-field-dropdown',
    splitButton: false,
    apperance: "field",
    data: dropdown,
    dropdownItemArialabel: true,
    onSelect: dropdownSelectHandle,
    onVisibleChange: onVisibleChange,
    prefixTemplate: prefixTemplate,
    suffixTemplate: suffixTemplate,
    value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value,
    disabled: readonly
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: !readonly && !disabled ? 0 : undefined,
    className: ClassNames('ap-field-dropdown-button-group', {
      'with-unit': selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.unit
    }),
    "aria-label": (_fieldDropdownButtonL = t('aria').fieldDropdownButtonLabel) === null || _fieldDropdownButtonL === void 0 ? void 0 : _fieldDropdownButtonL.replace('{title}', title)
  }, customIcon ? customIcon(selectedItem) : /*#__PURE__*/React.createElement(React.Fragment, null, (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.url) && /*#__PURE__*/React.createElement("img", {
    className: "ap-field-img",
    src: selectedItem.url,
    "aria-hidden": true
  }), (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.unit) && /*#__PURE__*/React.createElement("span", {
    className: "ap-field-unit",
    "aria-hidden": true
  }, selectedItem.unit)), /*#__PURE__*/React.createElement("span", {
    className: ClassNames('Appkit4-icon ap-field-icon-btn icon-down-chevron-outline', {
      'with-unit': selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.unit,
      up: visible
    }),
    "aria-hidden": true
  }))), allowClear && /*#__PURE__*/React.createElement("div", {
    className: "ap-field-suffix-wrapper",
    onBlur: function onBlur() {
      return setKeyboardFocus(false);
    }
  }, /*#__PURE__*/React.createElement("span", {
    role: "button",
    className: clearWrapperClass,
    tabIndex: value && value.length && !readonly && !disabled ? 0 : undefined,
    "aria-label": t('clear'),
    "aria-disabled": value.length === 0 || readonly || disabled,
    onClick: readonly || disabled ? undefined : handleClear,
    onKeyDown: readonly || disabled ? undefined : handleClearKeyDown
  })), revealer && /*#__PURE__*/React.createElement("div", {
    className: "ap-field-suffix-wrapper",
    onBlur: function onBlur() {
      return setKeyboardFocus(false);
    }
  }, /*#__PURE__*/React.createElement("span", {
    role: "button",
    className: revealWrapperClass,
    tabIndex: value && value.length ? 0 : undefined,
    "aria-label": reveal ? t('aria').revealPassword : t('aria').unrevealPassword,
    "aria-disabled": "false",
    onClick: changeReveal,
    onKeyDown: changeRevealKeyDown
  })), suffix && /*#__PURE__*/React.createElement("div", {
    className: "ap-field-suffix-wrapper",
    onBlur: function onBlur() {
      return setKeyboardFocus(false);
    }
  }, suffix)), /*#__PURE__*/React.createElement("div", {
    className: "ap-field-content"
  }, children, error && errorNode)));
});
export default Input;